const TextAdventure = () => {
  return (
    <div>
      <p>
        A text-based game that allows a player to type commands to interact with
        the adventure narrative, based on the Colossal Cave Adventure.
      </p>
      <br />
      <p>
        Commands are <code>look</code>, <code>score</code>, <code>n/w/s/e</code>
        , <code>drop</code>, <code>get</code> and <code>inv</code>.
      </p>
    </div>
  );
};

export default TextAdventure;
